import CryptoJS from "crypto-js";

export const trvLoader = 'https://cdn.shipratravel.com/trv/';

// Shared Document Type list for Holiday/Visa uploads - keep in sync with CRMAPI.BAL.Enums.DocumentTypeOptions
export const DOCUMENT_TYPES = [
  'ID Proof',
  'Passport',
  'PAN Card',
  'Final Booking Confirmation',
  'Proforma Invoice',
  'Tax Invoice',
  'Agreed costing as per Vendor',
];

// Holiday Document Type list (upload dropdown) - subset of DocumentTypeOptions.All on the API
export const HOLIDAY_DOCUMENT_TYPES = [
  'ID Proof',
  'Passport',
  'PAN Card',
  'TCS Declaration',
  'Final Package',
  'Flight Tickets',
  'Hotel Vouchers',
  'Vendor Cost',
];
// Only these types are allowed to show up on the Document Approval tab.
export const APPROVAL_DOCUMENT_TYPES = [
  'Proforma Invoice',
  'Tax Invoice',
  'Agreed costing as per Vendor',
  'Vendor Cost',
];

// a Supervisor may reopen only these two - mirrors DocumentTypeOptions.ReopenTypes on the API
export const REOPEN_DOCUMENT_TYPES = [
  'Proforma Invoice',
  'Agreed costing as per Vendor',
  'Vendor Cost',
];

export const TBOSuppliers = ['Riya Travels', 'TSI Yatra', 'IATA', 'ConnexPay', 'PhonePe', 'HDFC', 'PinLabs', 'PayU'];

export const OtherSuppliers = ['TravelFusion', 'Airline Portal', 'SkyBird', 'GTT', 'Authorize.net', 'Kiwi', 'ConnexPay'];

// a customer outside India gets no GST allocation and needs no state
export const HolidayCountries = ["India", "Other"];

export const IndianStates = [
  "Andaman and Nicobar Islands",
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chandigarh",
  "Chhattisgarh",
  "Dadra and Nagar Haveli and Daman and Diu",
  "Delhi",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Jammu and Kashmir",
  "Karnataka",
  "Kerala",
  "Lakshadweep",
  "Ladakh",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Puducherry",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
];


export const InquirySources = [
  { name: 'Chat', value: 1 },
  { name: 'Fresh Call', value: 2 },
  { name: 'Reference', value: 3 },
  { name: 'Repeated Customer', value: 4 },
  { name: 'Email', value: 5 },
  { name: 'Google', value: 6 },
  { name: 'Post Sales Call', value: 7 },
  { name: 'Sulekha', value: 8 },
  { name: 'Call Transfer', value: 9 },
  { name: 'Facebook Leads', value: 10 },
  { name: 'MTI Reference', value: 11 },
  { name: 'Business AUS', value: 12 },
  { name: 'HelloTravel', value: 13 },
  { name: 'TRV Website', value: 14 },
  { name: 'MTI Website', value: 15 },
  { name: 'Shipra Website', value: 16 },
  { name: 'Travanya Website', value: 17 },
  { name: 'Dummy Ticket', value: 18 },
  { name: 'Split Booking/Same Booking', value: 19 },


];

export const HolidayTypes = [
  { name: 'Leisure', value: 1 },
  { name: 'Honeymoon', value: 2 },
  { name: 'Round Trip', value: 3 },
  { name: 'One Way', value: 4 },
  { name: 'Adventure', value: 5 },
  { name: 'Wildlife', value: 6 },
  { name: 'Cultural', value: 7 },
  { name: 'Safari', value: 8 },
  { name: 'Beach', value: 9 },
  { name: 'Hill Station', value: 10 },
  { name: 'Heritage', value: 11 },
  { name: 'Pilgrimage', value: 12 },
];

export const HolidayVisa = [
  { name: 'Valid & Stamped', value: 1 },
  { name: 'Expired', value: 2 },
  { name: 'Advance Payroll', value: 3 },
  { name: 'US Citizen', value: 4 },
  { name: 'Green Card', value: 5 },
  { name: 'Tourist Visa', value: 6 },
];

export const HolidayStatus = [
  { name: 'Pending', value: 1 },
  { name: 'Follow-Up', value: 2 },
  { name: 'Call-Back', value: 3 },
  { name: 'Fake', value: 4 },
  { name: 'Cancelled', value: 5 },
  { name: 'Hold', value: 6 },
  { name: 'Duplicate', value: 7 },
  { name: 'Waiting Payment', value: 8 },
  { name: 'Sale', value: 9 },
  // { name: 'Closed', value: 10 }
];

export const VisaStatus = [
  { name: 'Pending', value: 1 },
  { name: 'Processing', value: 2 },
  { name: 'Completed', value: 3 },
  { name: 'Hold', value: 4 },
  { name: 'Follow Up', value: 5 },
  { name: 'Closed', value: 6 },
  { name: 'Visa Grant', value: 7 },
  { name: 'Refused', value: 8 },
  { name: 'Appointment Booked', value: 9 },
  { name: 'File At High Commission', value: 10 },
  { name: 'Call-Back', value: 11 },


];

export const HotelStatus = [
  { name: 'Pending', value: 1 },
  { name: 'Vouchered', value: 2 },
  { name: 'Completed', value: 3 },
  { name: 'Hold', value: 4 },
  { name: 'Closed', value: 5 },


];

export const VisaTypes = [
  { name: 'Tourist', value: 1 },
  { name: 'Visitor', value: 2 },
  { name: 'Student', value: 3 },
];

export const HolidayDestinations = [
  'Baku', 'Bali', 'Cambodia', 'Dubai', 'Golden Triangle', 'Kashmir', 'Kerala', 'Malaysia', 'Maldives', 'Mauritius',
  'North East', 'Rajasthan', 'Singapore', 'Sri lanka', 'Thailand', 'Vietnam', 'Himachal', 'Nepal'
];

// export const CancellationReasons = [
//   { name: 'No response pre quot', value: 1 },
//   { name: 'No response post quot', value: 2 },
//   { name: 'Low Budget', value: 3 },
//   { name: 'Language barrier', value: 4 },
//   { name: 'Just checking', value: 5 },
//   { name: 'Booked elsewhere', value: 6 },
//   { name: 'Will revert if req.', value: 7 },
//   { name: 'Pax denied', value: 8 },
//   { name: 'Plan cancelled', value: 9 },
//   { name: 'Trust issue', value: 10 },
//   { name: 'Alternate Product Inquiry', value: 11 },
//   { name: 'Availability Issue Flight', value: 12 },
//   { name: 'Availability Issue Hotel', value: 13 },
//   { name: 'Wrong Number', value: 14 },
//   { name: 'Dates not Suitable', value: 15 },
//   { name: 'Document Issue', value: 16 },
//   { name: 'Duplicate Query', value: 17 },
//   { name: 'Flight Inquiry', value: 18 },
//   { name: 'Future Travel', value: 19 },
//   { name: 'Just Enquired', value: 20 },
//   { name: 'Leave Issue', value: 21 },
//   { name: 'Need assured Visa', value: 22 },
//   { name: 'Visa inquiry', value: 23 },
//   { name: 'Not Inquired', value: 24 },
//   { name: 'Not Interested', value: 25 },
//   { name: 'Not Relevant', value: 26 },
//   { name: 'Visa Appointment dates not available', value: 27 },
//   { name: 'Pax stopped Responding', value: 28 },
//   { name: 'Pricing issue', value: 29 },
//   { name: 'Test', value: 30 },
//   { name: 'Unable to Connect', value: 31 },
// ];

export const CancellationReasons = [
  { name: 'No response pre quote', value: 1 },
  { name: 'No response post quote', value: 2 },
  { name: 'Low Budget', value: 3 },
  { name: 'Language barrier', value: 4 },
  { name: 'Just checking', value: 5 },
  { name: 'Booked elsewhere', value: 6 },
  { name: 'Travel Plan changed', value: 7 },
  { name: 'Not Inquired', value: 8 },
  { name: 'Trust issue', value: 9 },
  { name: 'Irrelevant lead', value: 10 },
  { name: 'Availability & Schedule Issues', value: 11 },
  { name: 'Visa Document Issue', value: 12 },
  { name: 'Duplicate Query', value: 13 },
  { name: 'Not Interested', value: 14 },
  { name: 'Getting better deal from somewhere else', value: 15 },
  { name: 'Unable to Connect', value: 16 },
];

export const CallbackReasons = [
  { name: 'No response', value: 1 },
  { name: 'Unable to connect', value: 2 },
  { name: 'Invalid/Switched off', value: 3 },
  { name: 'Complete travel details not available', value: 4 },
];

// Time slots for Call-Back / Follow-Up (9:00 AM to 8:00 PM only, 5-minute gaps)
export const CallbackTimeOptions = (() => {
  const options = [];
  for (let minutes = 9 * 60; minutes <= 20 * 60; minutes += 5) {
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    const hour12 = h % 12 === 0 ? 12 : h % 12;
    const ampm = h < 12 ? 'AM' : 'PM';
    options.push({ name: `${hour12}:${m.toString().padStart(2, '0')} ${ampm}`, value: `${h}:${m}` });
  }
  return options;
})();

export const dayOptions = [
  {
    value: 1,
    label: "1",
  },
  {
    value: 2,
    label: "2",
  },
  {
    value: 3,
    label: "3",
  },
  {
    value: 4,
    label: "4",
  },
  {
    value: 5,
    label: "5",
  },
  {
    value: 6,
    label: "6",
  },
  {
    value: 7,
    label: "7",
  },
  {
    value: 8,
    label: "8",
  },
  {
    value: 9,
    label: "9",
  },
  {
    value: 10,
    label: "10",
  },
  {
    value: 11,
    label: "11",
  },
  {
    value: 12,
    label: "12",
  },
  {
    value: 13,
    label: "13",
  },
  {
    value: 14,
    label: "14",
  },
  {
    value: 15,
    label: "15",
  },
  {
    value: 16,
    label: "16",
  },
  {
    value: 17,
    label: "17",
  },
  {
    value: 18,
    label: "18",
  },
  {
    value: 19,
    label: "19",
  },
  {
    value: 20,
    label: "20",
  },
  {
    value: 21,
    label: "21",
  },
  {
    value: 22,
    label: "22",
  },
  {
    value: 23,
    label: "23",
  },
  {
    value: 24,
    label: "24",
  },
  {
    value: 25,
    label: "25",
  },
  {
    value: 26,
    label: "26",
  },
  {
    value: 27,
    label: "27",
  },
  {
    value: 28,
    label: "28",
  },
  {
    value: 29,
    label: "29",
  },
  {
    value: 30,
    label: "30",
  },
  {
    value: 31,
    label: "31",
  },
];

export const monthOptions = [
  {
    value: 1,
    label: "Jan",
    fullName: "January",
  },
  {
    value: 2,
    label: "Feb",
    fullName: "February",
  },
  {
    value: 3,
    label: "Mar",
    fullName: "March",
  },
  {
    value: 4,
    label: "Apr",
    fullName: "April",
  },
  {
    value: 5,
    label: "May",
    fullName: "May",
  },
  {
    value: 6,
    label: "Jun",
    fullName: "June",
  },
  {
    value: 7,
    label: "Jul",
    fullName: "July",
  },
  {
    value: 8,
    label: "Aug",
    fullName: "August",
  },
  {
    value: 9,
    label: "Sep",
    fullName: "September",
  },
  {
    value: 10,
    label: "Oct",
    fullName: "October",
  },
  {
    value: 11,
    label: "Nov",
    fullName: "November",
  },
  {
    value: 12,
    label: "Dec",
    fullName: "December",
  },
];

export const currentCoupons = [
  {
    name: "FLYONE",
    discount: 200,
    minPrice: 0,
    minPax: 0,
    discountPercentage: 10,
    isReturnCouponOnly: false,
  },
  {
    name: "FLYDOUBLE",
    discount: 400,
    minPrice: 0,
    minPax: 0,
    discountPercentage: 10,
    isReturnCouponOnly: false,
  }, {
    name: "FAMILYFUN",
    discount: 600,
    minPrice: 0,
    minPax: 0,
    discountPercentage: 10,
    isReturnCouponOnly: false,
  },
  {
    name: "What you see is What you get",
    discount: "",
    minPrice: 0,
    minPax: 0,
    discountPercentage: 10,
    isReturnCouponOnly: false,
  }, {
    name: "EMI option available on HDFC cards",
    discount: "",
    minPrice: 0,
    minPax: 0,
    discountPercentage: 10,
    isReturnCouponOnly: false,
  },
];

export const specialFares = {
  Saver: {
    baggage: {
      cabin: '7 kg',
      checkIn: '15 kg'
    },
    changes: 'Standard',
    addOns: {
      seat: '',
      meal: ''
    }
  },
  Flexi: {
    baggage: {
      cabin: '7 kg',
      checkIn: '15 kg'
    },
    changes: 'Lower',
    addOns: {
      seat: 'Free Standard Seats',
      meal: 'Free Meals'
    }
  },
  Super6E: {
    baggage: {
      cabin: '7 kg',
      checkIn: '20 kg'
    },
    changes: 'Lowest',
    addOns: {
      seat: 'Free Seats Including XL Seats',
      meal: 'Free Meals'
    }
  }
}
export const paymentModes = [
  { name: "Credit Card", value: 1 },
  { name: "Debit Card", value: 2 },
  { name: "UPI", value: 3 },
  { name: "Net Banking", value: 4 },
  { name: "Merchant Charged", value: 5 },
  { name: "Bank Transfer", value: 6 },
  { name: "International Ticket(GPM Adjusted)", value: 7 },
  { name: "Zelle Pay", value: 8 },
  { name: "Cash", value: 9 }
];

export const generateYearOptions = (startYear, endYear) => Array.from({ length: endYear - startYear + 1 }, (_, i) => {
  const year = startYear + i;
  return { value: year, label: String(year) };
});

export const Encrypt = (str) => {
  const key = CryptoJS.enc.Utf8.parse("E#KeySh!pra@@0#0");
  const iv = CryptoJS.enc.Utf8.parse("E#KeySh!pra@@0#0");
  var encrypted = CryptoJS.AES.encrypt(str, key, {
    keySize: 128 / 8,
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.toString();
};

export const Decrypt = (str) => {
  const key = CryptoJS.enc.Utf8.parse("E#KeySh!pra@@0#0");
  const iv = CryptoJS.enc.Utf8.parse("E#KeySh!pra@@0#0");
  var decrypt = CryptoJS.AES.decrypt(str, key, {
    keySize: 128 / 8,
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  return decryptedStr;
};